import type { ViewId } from 'cadenza/workbook/api/view-id';
import { createNotification } from 'cadenza/workbook/notifications/workbook-notifications';

import i18n from './workbook-map-view-notification.properties';

export function couplingLayerExceededNotification(viewId: ViewId) {
  return createNotification('WARNING', 'WORKBOOK_UPDATE', 'GENERIC', viewId, {
    title: i18n('couplingLayerLimitExceeded.title'),
    detail: i18n('couplingLayerLimitExceeded.message'),
  });
}
